import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

// Paraphrased & summarized content inspired by the public site, not verbatim.
// Feel free to adjust tone or length.

export default function About() {
  const { t } = useTranslation();
  
  const values = [
    { title: t('about.values.quality'), desc: t('about.values.quality.desc') },
    { title: t('about.values.customer'), desc: t('about.values.customer.desc') },
    { title: t('about.values.innovation'), desc: t('about.values.innovation.desc') },
    { title: t('about.values.integrity'), desc: t('about.values.integrity.desc') },
  ];

  const specialties = [
    t('about.specialties.european'),
    t('about.specialties.japanese'),
    t('about.specialties.domestic'),
    t('about.specialties.detailing'),
    t('about.specialties.mechanical'),
  ];
  return (
    <>
      <SEO
        title="About Vigor Auto - Certified Car Garage Ras Al Khor Dubai | Dealer Alternative"
        description="Vigor Auto Garage Ras Al Khor Dubai - trusted dealer-alternative car repair workshop. 15+ years serving Dubai with certified technicians, European/Japanese/Korean/American car expertise. Serving Nad Al Hamar, Al Awir & International City."
        keywords="about vigor auto, car garage Ras Al Khor, auto repair Ras Al Khor, dealer alternative dubai, certified car garage dubai, independent car workshop dubai, european car service dubai, japanese car service dubai, auto repair specialists Ras Al Khor, car service centre Ras Al Khor"
      />
      <div className="bg-gray-50">
        {/* Hero */}
  <section className="relative overflow-hidden bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 text-white py-12 md:py-20">
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_30%_40%,#F5D313,transparent_60%)]" />
          <div className="max-w-7xl mx-auto px-4 relative">
            <p className="uppercase tracking-widest text-xs font-semibold text-[#F5D313]/80">{t('about.badge')}</p>
            <h1 className="mt-4 text-3xl md:text-5xl font-extrabold leading-tight max-w-3xl">{t('about.title')}</h1>
            <p className="mt-6 max-w-2xl text-slate-200 text-sm md:text-base leading-relaxed">
              {t('about.subtitle')}
            </p>
          </div>
        </section>

       

        {/* Our Story */}
        <section className="py-10 md:py-16">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-800">{t('about.story.title')}</h2>
                <p className="mt-5 text-slate-600 leading-relaxed">
                  {t('about.story.p1')}
                </p>
                <p className="mt-4 text-slate-600 leading-relaxed">
                  {t('about.story.p2')}
                </p>
              </div>
              <div className="relative">
                <div className="pointer-events-none absolute -top-6 -left-6 w-32 h-32 rounded-full bg-[#F5D313]/15 blur-xl" aria-hidden="true" />
                <img
                  src="/images/about.png"
                  alt="Vigor Auto Garage Dubai – Our workshop"
                  loading="lazy"
                  className="relative w-full h-64 md:h-80 object-cover rounded-xl shadow-lg border border-slate-200"
                />
              </div>
            </div>
          </div>
        </section>

  {/* Our Values (reduced top spacing) */}
  <section className="pt-6 md:pt-8 pb-12 md:pb-16">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-800">{t('about.values.title')}</h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              {t('about.values.subtitle')}
            </p>
            <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map(v => (
                <div key={v.title} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200/80">
                  <h3 className="font-bold text-slate-800">{v.title}</h3>
                  <p className="mt-2 text-sm text-slate-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Specialties */}
  <section className="py-10 md:py-16 lg:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-center text-2xl md:text-3xl font-bold text-slate-900">{t('about.specialties.title')}</h2>
            <p className="mt-4 text-center max-w-2xl mx-auto text-slate-600">
              {t('about.specialties.subtitle')}
            </p>
            <div className="mt-12 max-w-4xl mx-auto">
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 text-slate-700">
                {specialties.map(s => (
                  <li key={s} className="flex items-center gap-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-[#F5D313]" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* Leadership section removed as requested */}
      </div>
    </>
  );
}
